import { forwardRef } from 'react';

export default forwardRef(function SelectTag({ className, ...props }, ref) {
  return <div ref={ref} className="flex flex-wrap gap-2" {...props} />;
});
